// Central config for the contact form provider.
// Swap FORMSPREE_FORM_ID (or replace the whole hook usage) when moving to a
// custom backend / CRM — the Contact UI never needs to change.
export const FORMSPREE_FORM_ID = "xlgqjnzz";
